import { render } from "./address_match.html?vue&type=template&id=5b5be408&external"
import script from "./address_match.js?vue&type=script&lang=js&external"
export * from "./address_match.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__